import type { StandingsListRow } from '../../../../services/competition/getScheduleStandings'

/** One collapsible group on the Standings tab. */
export interface StandingsGroup<Row extends StandingsListRow> {
  name: string
  rows: Row[]
}

/**
 * Splits the flat standings response into one group per schedule (division,
 * conference, …), keyed by schedule id in the order each first appears.
 *
 * A row with a null `team` still creates its group — the API reports an empty
 * division that way, and it should render as an empty table — but is not
 * itself kept as a row.
 */
export const groupStandingsBySchedule = <Row extends StandingsListRow>(
  rows: Row[]
): Record<string, StandingsGroup<Row>> =>
  rows.reduce<Record<string, StandingsGroup<Row>>>((groups, row) => {
    const group = groups[row.schedule.id] ?? {
      name: row.schedule.name,
      rows: [],
    }
    group.name = row.schedule.name
    if (row.team !== null) {
      group.rows.push(row)
    }
    groups[row.schedule.id] = group
    return groups
  }, {})
